{
    "ShowMore": "Zeig mehr",
    "ShowLess": "Zeige weniger",
    "NAME": "LanguageSnackbar"
}